var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 277,
    viewBox: "0 0 268 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.932 261.821L159.245 261.538L159.262 122.171L153.778 122.156C147.503 137.278 130.087 137.332 122.126 125.774C120.981 124.111 120.213 122.21 120.101 122.21L113.905 122.216L113.932 261.821Z",
    fill: "#97989A",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.227 130.34C145.533 130.34 152.267 123.794 152.267 115.717C152.267 107.641 145.533 101.094 137.227 101.094C128.92 101.094 122.187 107.641 122.187 115.717C122.187 123.794 128.92 130.34 137.227 130.34Z",
    fill: "#E93237",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.229 123.835C141.437 123.835 144.848 120.518 144.848 116.427C144.848 112.336 141.437 109.02 137.229 109.02C133.021 109.02 129.61 112.336 129.61 116.427C129.61 120.518 133.021 123.835 137.229 123.835Z",
    stroke: "#AAACAE",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.826 146.2C152.366 146.2 165.775 133.163 165.775 117.081C165.775 100.999 152.366 87.9624 135.826 87.9624C119.285 87.9624 105.876 100.999 105.876 117.081C105.876 133.163 119.285 146.2 135.826 146.2Z",
    stroke: "#6D7175",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.824 158.571C159.392 158.571 178.498 139.995 178.498 117.081C178.498 94.1668 159.392 75.5913 135.824 75.5913C112.256 75.5913 93.1504 94.1668 93.1504 117.081C93.1504 139.995 112.256 158.571 135.824 158.571Z",
    stroke: "#6D7175",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.829 171.702C166.857 171.702 192.01 147.247 192.01 117.08C192.01 86.9135 166.857 62.4585 135.829 62.4585C104.801 62.4585 79.6484 86.9135 79.6484 117.08C79.6484 147.247 104.801 171.702 135.829 171.702Z",
    stroke: "#6D7175",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.826 185.728C174.821 185.728 206.433 154.994 206.433 117.081C206.433 79.1677 174.821 48.4331 135.826 48.4331C96.8314 48.4331 65.2197 79.1677 65.2197 117.081C65.2197 154.994 96.8314 185.728 135.826 185.728Z",
    stroke: "#6D7175",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.827 201.097C183.552 201.097 222.241 163.481 222.241 117.08C222.241 70.6795 183.552 33.0642 135.827 33.0642C88.102 33.0642 49.4131 70.6795 49.4131 117.08C49.4131 163.481 88.102 201.097 135.827 201.097Z",
    stroke: "#6D7175",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.824 213.212C190.431 213.212 234.698 170.173 234.698 117.081C234.698 63.99 190.431 20.9509 135.824 20.9509C81.2176 20.9509 36.9502 63.99 36.9502 117.081C36.9502 170.173 81.2176 213.212 135.824 213.212Z",
    stroke: "#6D7175",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCall1);
export default __webpack_public_path__ + "static/media/logo_call_1.50ec91542162cba7bbc2d3c9cba8daac.svg";
export { ForwardRef as ReactComponent };